'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const VolumeItemBox = styled(Box)(({theme}) => ({
    boxShadow: `1px 1px 0 ${theme.palette.custom?.lightGray}`,
    border: `1px solid ${theme.palette.custom?.borderColorVolumeActiveArchive}`,
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    borderRadius: '.5rem',
    padding: '1rem',
    marginBottom: '.5rem',
    position: 'relative',
    color: theme.palette.custom?.textColorVolumeArchive,
    '&[aria-selected="true"]': {
        boxShadow: `1px 1px 0 ${theme.palette.custom?.lightGray}`,
        backgroundImage: 'linear-gradient(to bottom, #d3b976, #c7a54f)',
        border: `1px solid ${theme.palette.custom?.borderColorVolumeActiveArchive}`,
        transition: 'all 0.3s ease-in-out',
        color: theme.palette.custom?.textColorVolumeActiveArchive,
    }
}));

export default VolumeItemBox;
